module.exports = __webpack_public_path__ + "img/6.be05cb09.jpg";